import { Navbar } from "../components/landing/Navbar";
import { Hero } from "../components/landing/Hero";
import { ChiSono } from "../components/landing/ChiSono";
import { Identificati } from "../components/landing/Identificati";
import { Servizi } from "../components/landing/Servizi";
import { Approccio } from "../components/landing/Approccio";
import { Risultati } from "../components/landing/Risultati";
import { Contatti } from "../components/landing/Contatti";
import { Faq } from "../components/landing/Faq";
import { Footer } from "../components/landing/Footer";

const Landing = () => {
  return (
    <main data-testid="landing-page" className="bg-ivory text-navy" translate="no">
      <Navbar />
      <Hero />
      <ChiSono />
      <Identificati />
      <Servizi />
      <Approccio />
      <Risultati />
      <Contatti />
      <Faq />
      <Footer />
    </main>
  );
};

export default Landing;
